// ReminderManager.js

class ReminderManager {
    // constructor() {
    //   this.UPI_REMINDER_KEY = 'upi_reminder_state';
    //   this.TERMS_REMINDER_KEY = 'terms_reminder_state';
    //   // ⚠️ TESTING: 1 minute interval
    //   this.REMINDER_INTERVAL = 1 * 60 * 1000; // 1 minute in milliseconds
    //   // ⚠️ TESTING: 30 seconds for daily check (so it shows faster)
    //   this.DAILY_CHECK_INTERVAL = 30 * 1000; // 30 seconds in milliseconds
    // }

  constructor() {
    this.UPI_REMINDER_KEY = "upi_reminder_state";
    this.TERMS_REMINDER_KEY = "terms_reminder_state";
    // ✅ PRODUCTION: 48 hours interval
    this.REMINDER_INTERVAL = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
    // ✅ PRODUCTION: 24 hours for daily check
    this.DAILY_CHECK_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  }

  shouldShowUPIReminder(hasUPI) {
    if (hasUPI) {
      localStorage.removeItem(this.UPI_REMINDER_KEY);
      return false;
    }

    const reminderState = this.getReminderState(this.UPI_REMINDER_KEY);

    console.log("🔍 UPI Reminder Check:", {
      hasUPI,
      reminderState,
      timeSinceLastShown: reminderState
        ? Date.now() - reminderState.lastShown
        : "first time",
      interval: this.REMINDER_INTERVAL,
      shouldShow:
        !reminderState ||
        Date.now() - reminderState.lastShown > this.REMINDER_INTERVAL,
    });

    // First time showing or 1 minute has passed
    if (
      !reminderState ||
      Date.now() - reminderState.lastShown > this.REMINDER_INTERVAL
    ) {
      // Check if we haven't shown it in the last 30 seconds
      if (
        !reminderState ||
        Date.now() - reminderState.lastShown > this.DAILY_CHECK_INTERVAL
      ) {
        return true;
      }
    }

    return false;
  }

  shouldShowTermsReminder(hasTerms) {
    if (hasTerms && hasTerms.length > 0) {
      localStorage.removeItem(this.TERMS_REMINDER_KEY);
      return false;
    }

    const reminderState = this.getReminderState(this.TERMS_REMINDER_KEY);

    console.log("🔍 Terms Reminder Check:", {
      hasTerms: hasTerms?.length || 0,
      reminderState,
      timeSinceLastShown: reminderState
        ? Date.now() - reminderState.lastShown
        : "first time",
      interval: this.REMINDER_INTERVAL,
      shouldShow:
        !reminderState ||
        Date.now() - reminderState.lastShown > this.REMINDER_INTERVAL,
    });

    if (
      !reminderState ||
      Date.now() - reminderState.lastShown > this.REMINDER_INTERVAL
    ) {
      if (
        !reminderState ||
        Date.now() - reminderState.lastShown > this.DAILY_CHECK_INTERVAL
      ) {
        return true;
      }
    }

    return false;
  }

  // Update reminder state when shown
  markReminderShown(key, action = "shown") {
    const state = {
      lastShown: Date.now(),
      lastAction: action,
      showCount: this.getReminderState(key)?.showCount + 1 || 1,
    };
    localStorage.setItem(key, JSON.stringify(state));
  }

  // Handle user action (cancel/setup)
  handleUserAction(key, action) {
    const state = this.getReminderState(key);
    if (state) {
      state.lastAction = action;
      state.lastShown = Date.now();
      localStorage.setItem(key, JSON.stringify(state));
    }
  }

  // Get reminder state
  getReminderState(key) {
    const state = localStorage.getItem(key);
    return state ? JSON.parse(state) : null;
  }

  // Clear all reminders
  clearAllReminders() {
    localStorage.removeItem(this.UPI_REMINDER_KEY);
    localStorage.removeItem(this.TERMS_REMINDER_KEY);
  }
}

export default new ReminderManager();
